import React from 'react';
import '../App.css';
import {useNavigate, useLocation} from 'react-router-dom';
import homeImage from '../Assets/homeIcon.png';
import playImage from '../Assets/launchIcon.png';
import profileImage from '../Assets/profileIcon.png';

export default function Footer() {
    const navigate = useNavigate();
    const location = useLocation();
    const handleToHome = () => {
        navigate('/home');
    };
    const handleToStarting = () => {
        navigate('/starting');
    };

    const handleToEditProfile = () => {
        navigate('/change_profile');
    };

    const isHomeActive = location.pathname === '/home';
    const isStartingActive = location.pathname === '/starting';
    const isProfileActive = location.pathname === '/change_profile';

    return (
        <footer className="mb-4 p-1 mx-3">
            <div className="footer mx-auto p-3 rounded-4">
                <div className="container">
                    <div className="row">
                        <div className={`col-4  ${isHomeActive && 'deep-pink rounded-3'}`}>
                            <div className="mt-1 p-1 d-flex flex-column align-items-center" onClick={handleToHome}>
                                <img src={homeImage} alt='homeIcon'/>
                                {isHomeActive ?
                                    <span className="mt-1 fw-bold text-white h6"><u>Home</u></span>
                                    :
                                    <span className="mt-1 fw-bold text-white h6">Home</span>
                                }
                            </div>
                        </div>
                        <div className={`col-4  ${isStartingActive && 'deep-pink rounded-3'}`}>
                            <div className="mt-1 p-1 d-flex flex-column align-items-center" onClick={handleToStarting}>
                                <img src={playImage} alt='launchIcon'/>
                                {isStartingActive ?
                                    <span className="mt-1 fw-bold text-white h6"><u>Launch</u></span>
                                    :
                                    <span className="mt-1 fw-bold text-white h6">Launch</span>
                                }
                            </div>
                        </div>
                        <div className={`col-4  ${isProfileActive && 'deep-pink rounded-3'}`}>
                            <div className="mt-1 p-1 d-flex flex-column align-items-center"
                                 onClick={handleToEditProfile}>
                                <img src={profileImage} alt='profileIcon'/>
                                {isProfileActive ?
                                    <span className="mt-1 fw-bold text-white h6"><u>Profile</u></span>
                                    :
                                    <span className="mt-1 fw-bold text-white h6">Profile</span>
                                }
                            </div>
                        </div>
                    </div>
                </div>


                {/*<div className="rounded-4  py-1 px-4 ">*/}
                {/*	<div className="mt-1 p-1 d-flex flex-column align-items-center" onClick={handleToHome}>*/}

                {/*	</div>*/}
                {/*</div>*/}


                {/*<div className="mt-1 p-1 d-flex flex-column align-items-center"  onClick={handleToStarting}>*/}
                {/*	<img src={playImage} alt='launchIcon'/>*/}
                {/*	<span className="mt-1 text-white h6">Launch</span>*/}
                {/*</div>*/}
                {/*<div className="mt-1 p-1 d-flex flex-column align-items-center"  onClick={handleToEditProfile}>*/}
                {/*	<img src={profileImage} alt='profileIcon'/>*/}
                {/*	<span className="mt-1 text-white h6">Profile</span>*/}
                {/*</div>*/}
            </div>
        </footer>
    );
}
